<template>
  <div class="flex flex-col">
    <div class="flex items-center justify-center sm:justify-start">
      <span
        v-if="hasIconLeft"
        :class="`mr-2 h-6 w-6 p-1 text-white ${getColorClass({
          type: 'bg',
          value: '800'
        })} rounded`"
      >
        <slot name="icon-left" />
      </span>
      <h3 class="text-lg font-semibold text-foreground">
        {{ title }}
      </h3>
      <span v-if="hasIconRight" class="ml-2">
        <slot name="icon-right" />
      </span>
    </div>
    <p v-if="subtitle" class="mt-1 text-center text-sm font-light text-muted-foreground sm:text-left">
      {{ subtitle }}
    </p>
  </div>
</template>

<script lang="ts">
import { getColorClass } from '@/utils/colorClass'

export default defineComponent({
  name: 'Headline',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    },
    hasIconLeft: {
      type: Boolean,
      default: true
    },
    hasIconRight: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      getColorClass
    }
  }
})
</script>
